<app-breadcrumb></app-breadcrumb>
<div class="row">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input class="form-control rounded-0" type="text" placeholder="filter car info" [(ngModel)]="filterKey">
            <div class="input-group-append">
                <button class="btn btn-outline-primary rounded-0" type="button">Filter</button>
            </div>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input class="form-control rounded-0" type="text" placeholder="Latitude" [(ngModel)]="dtgGpsLat">
            <input class="form-control rounded-0" type="text" placeholder="Longitude" [(ngModel)]="dtgGpsLng">
            <div class="input-group-append">
                <button class="btn btn-outline-primary rounded-0" type="button" (click)="clickFindAddr()">Find Addr</button>
            </div>
        </div>
    </div>
    <div class="col">
        <input class="form-control form-control-sm rounded-0" type="text" placeholder="Addr"  [(ngModel)]="dtgGpsAddr">
    </div>
</div>

<div class="card mt-3">
    <div class="card-header">
        <div class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0">
                Processor Packet
            </h5>
            <div class="badge" [ngClass]="connectionStateMessageClassProcess">
                {{connectionStateMessageProcess}}
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-auto overflow-auto" style="height: 25vh;">
                <div class="table-responsive">
                    <table class="table table-sm table-bordered table-striped table-hover">
                        <thead class="thead-light">
                            <tr>
                                <th>
                                    시간
                                </th>
                                <th>
                                    개통번호
                                </th>
                                <th>
                                    차량번호
                                </th>
                                <th>
                                    확인
                                </th>
                            </tr>
                        </thead>
                        <tbody class="align-middle align-items-center">
                            <tr class="align-middle align-items-center small"
                                *ngFor="let item of listPacket | filterPacket:filterKey;">
                                <td>
                                    {{item.dataHead.regDt}}
                                </td>
                                <td>
                                    {{item.dataHead.unitId}}
                                </td>
                                <td>
                                    {{item.dataHead.dtgCarNo}}
                                </td>
                                <td>
                                    <button type="button" class="btn btn-sm btn-outline-info rounded-0"
                                        (click)="clickItemPacket(item)">
                                        확인
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        
            <div class="col overflow-auto" style="height: 25vh;">
                <div class="table-responsive">
                    <table class="table table-sm table-bordered table-striped table-hover">
                        <thead class="thead-light">
                            <tr>
                                <th>
                                    시간
                                </th>
                                <th>
                                    개통번호
                                </th>
                                <th>
                                    순서
                                </th>
                                <th>
                                    vin
                                </th>
                                <th>
                                    driver
                                </th>
                                <th>
                                    rpm
                                </th>
                                <th>
                                    확인
                                </th>
                            </tr>
                        </thead>
                        <tbody class="align-middle align-items-center">
                            <tr class="align-middle align-items-center small"
                                *ngFor="let item of listBody;">
                                <td>
                                    {{item.regDt | filterDateTime}}
                                </td>
                                <td>
                                    {{item.unitId}}
                                </td>
                                <td>
                                    {{item.dataIdx}}
                                </td>
                                <td>
                                    {{item.dtgVin}}
                                </td>
                                <td>
                                    {{item.dtgDriverLcsNo}}
                                </td>
                                <td>
                                    {{item.rpm}}
                                </td>
                                <td>
                                    <button type="button" class="btn btn-sm btn-outline-info rounded-0"
                                        data-toggle="modal" data-target="#modal-packet-json-view"
                                        (click)="clickItemPacketBody(item)">
                                        확인
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modal-packet-json-view">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Packet Json View</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <pre class="mb-0 overflow-auto" style="height: 50vh">{{selectedBody}}</pre>
            </div>
        </div>
    </div>
</div>